module.exports = __webpack_public_path__ + "static/header-457c467db9db27a5cd3ff41481cd62ea.png";